import { useState } from "react";
import { useNavigate } from "react-router-dom";
import NodeAPI from "../api";
import { TextField, Button, Box, Paper, Typography, Alert, Link } from "@mui/material";

const Register = () => {
    const [form, setForm] = useState({ username: "", email: "", password: "" });
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        setSuccessMessage("");

        try {
            await NodeAPI.post("/auth/register", form);
            setSuccessMessage("Registration successful. Please verify your email.");
            setTimeout(() => navigate("/"), 3000);
        } catch (error) {
            console.error(error);
            if (error.response && error.response.data && error.response.data.msg) {
                setErrorMessage(error.response.data.msg);
            } else {
                setErrorMessage("Registration failed. Please try again.");
            }
        }
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <Paper elevation={3} sx={{ padding: 4, width: 350, textAlign: "center" }}>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>Register</Typography>

                {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}
                {errorMessage && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage}</Alert>}

                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Username"
                        name="username"
                        type="text"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        required
                        value={form.username}
                        onChange={(e) => {
                            setForm({ ...form, username: e.target.value });
                            setErrorMessage("");
                            setSuccessMessage("");
                        }}
                    />
                    <TextField
                        label="Email"
                        name="email"
                        type="email"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        required
                        value={form.email}
                        onChange={(e) => {
                            setForm({ ...form, email: e.target.value });
                            setErrorMessage("");
                            setSuccessMessage("");
                        }}
                    />
                    <TextField
                        label="Password"
                        name="password"
                        type="password"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        required
                        value={form.password}
                        onChange={(e) => {
                            setForm({ ...form, password: e.target.value });
                            setErrorMessage("");
                            setSuccessMessage("");
                        }}
                    />
                    <Button 
                        type="submit" 
                        variant="contained" 
                        color="primary" 
                        fullWidth 
                        sx={{ mt: 2, fontWeight: "bold", "&:hover": { backgroundColor: "#1565c0" } }}
                    >
                        Register
                    </Button>
{/* Sign-up Link */}
<Typography variant="body2" sx={{ mt: 2 }}>
  Already have an account?{" "}
  <Link href="/login" underline="hover">
    Login
  </Link>
</Typography>

                </form>
            </Paper>
        </Box>
    );
};

export default Register;
